import { combineReducers } from 'redux';

import * as actionTypes from '../aciton-mgr/actionTypes';

const message = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_MESSAGE:
      return action.message;
    case actionTypes.SUBMIT_REPORT_SUCCESS:
      return "";
    default:
      return state;
  }
}

const snackBarMessage = (state = "", action) => {
  switch(action.type){
    case actionTypes.SUBMIT_REPORT_SUCCESS:
    case actionTypes.SUBMIT_REPORT_FAILURE:
    case actionTypes.CLOSE_ERROR_REPORT_FAILURE:
    case actionTypes.CLOSE_ERROR_REPORT_SUCCESS:
      return action.message;
    case actionTypes.CLOSE_SNACK_BAR:
      return "";
    default:
      return state;
  }
}

const openedSnackBar = (state = false, action) => {
  switch(action.type){
    case actionTypes.SUBMIT_REPORT_FAILURE:
    case actionTypes.SUBMIT_REPORT_SUCCESS:
    case actionTypes.CLOSE_ERROR_REPORT_FAILURE:
    case actionTypes.CLOSE_ERROR_REPORT_SUCCESS:
      return true;
    case actionTypes.CLOSE_SNACK_BAR:
      return false;
    default:
      return state;
  }
}

const openedDialog = (state = false, action) => {
  switch(action.type){
    case actionTypes.TOGGLE_REPORT_DIALOG:
      return !state;
    default:
      return state;
  }
}

export default combineReducers({
  message,
  snackBarMessage,
  openedSnackBar,
  openedDialog
});

const getCurrentState = state => state.errorReports.reportDialog;

export const getMessage = state => getCurrentState(state).message;

export const getOpenedSnackBar = state => getCurrentState(state).openedSnackBar;

export const getSnackBarMessage = state => getCurrentState(state).snackBarMessage;

export const getOpenedDialog = state => getCurrentState(state).openedDialog;